import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import "../scss/_resourceUpload.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-regular-svg-icons";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import { faEnvelope as solidEnvelope } from "@fortawesome/free-solid-svg-icons";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import emailjs from "@emailjs/browser";
import { useDropzone } from "react-dropzone";

function ResourceUpload() {
    const { t } = useTranslation();

    const [name, setName] = useState("");
    const [date, setDate] = useState("");
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const [file, setFile] = useState(null);
    const [errors, setErrors] = useState({});

    const validateForm = () => {
        const errors = {};
        if (!name) {
            errors.name = "Name is required";
        }
        if (!date) {
            errors.date = "Date is required";
        }
        if (!email) {
            errors.email = "Email is required";
        }
        if (!message) {
            errors.message = "Details are required";
        }
        if (!file) {
            errors.file = "Resource file is required";
        }
        setErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const navigate = useNavigate();
    const goToSubmissionPage = () => {
        navigate("/Submission");
    };

    const onDrop = (acceptedFiles) => {
        setFile(acceptedFiles[0]);
    };

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
    });

    function sendEmail(e) {
        e.preventDefault();

        if (!validateForm()) {
            return;
        }

        const reader = new FileReader();
        reader.onloadend = () => {
            const base64File = reader.result.split(",")[1];
            const templateParams = {
                from_name: name,
                email: email,
                date: date,
                message: message,
                file: base64File,
                fileName: file.name,
            };

            emailjs
                .send(
                    process.env.REACT_APP_SERVICE_ID,
                    process.env.REACT_APP_RESOURCEUPLOAD_TEMPLATE_ID,
                    templateParams,
                    process.env.REACT_APP_OPTIONS
                )
                .then(() => {
                    goToSubmissionPage();
                    setName("");
                    setDate("");
                    setEmail("");
                    setMessage("");
                    setFile(null);
                })
                .catch((error) => {
                    console.error("Failed to send email:", error);
                    alert(
                        `Failed to send email: ${error.text || error.message}`
                    );
                });
        };
        reader.readAsDataURL(file);
    }

    return (
        <div className="resourceUp">
            <div className="resourceUp-spline">
                <h1>{t("resourceUpSpline")}</h1>
            </div>
            <div className="resourceUp-bottom">
                <div className="resourceUp-bottom-left">
                    <h1 className="text">{t("resourceUpTitle")}</h1>
                    <h4>{t("contact")}</h4>
                    <div className="resourceUp-bottom-left-buttonBox">
                        <button className="button phone">
                            <FontAwesomeIcon icon={faPhone} />
                        </button>
                        <p>&#124;</p>
                        <button className="button email">
                            <a href="mailto:hci4goodresearch@gmail.com">
                                <FontAwesomeIcon icon={faEnvelope} />
                            </a>

                            <a href="mailto:hci4goodresearch@gmail.com">
                                hci4goodresearch@gmail.com
                            </a>
                        </button>
                    </div>
                </div>
                <div className="resourceUp-bottom-right">
                    <h3>{t("contactFormTitle")}</h3>
                    <form
                        className="resourceUp-bottom-right-form"
                        onSubmit={sendEmail}
                    >
                        <input
                            type="text"
                            placeholder={t("namePlaceholder")}
                            className="formBoxes"
                            onChange={(e) => setName(e.target.value)}
                            value={name}
                        />
                        {errors.name && <p className="error">{errors.name}</p>}
                        <input
                            type="text"
                            placeholder={t("datePlaceholder")}
                            className="formBoxes"
                            onChange={(e) => setDate(e.target.value)}
                            value={date}
                        />
                        {errors.date && <p className="error">{errors.date}</p>}
                        <input
                            type="email"
                            placeholder={t("emailPlaceholder")}
                            className="formBoxes"
                            onChange={(e) => setEmail(e.target.value)}
                            value={email}
                        />
                        {errors.email && (
                            <p className="error">{errors.email}</p>
                        )}
                        <input
                            type="text"
                            placeholder="Details"
                            className="formBoxes details"
                            onChange={(e) => setMessage(e.target.value)}
                            value={message}
                        />
                        {errors.message && (
                            <p className="error">{errors.message}</p>
                        )}
                        <div
                            {...getRootProps()}
                            className={`dropzone ${isDragActive ? "active" : ""}`}
                        >
                            <input {...getInputProps()} />
                            {isDragActive ? (
                                <p>Drop the file here ...</p>
                            ) : (
                                <p>
                                    Drag &apos;n&apos; drop a file here, or
                                    click to select one
                                </p>
                            )}
                        </div>
                        {file && <p>{file.name}</p>}
                        {errors.file && <p className="error">{errors.file}</p>}
                        <motion.button
                            className="resourceUp-bottom-right-form-submit"
                            type="submit"
                            whileHover={{ scale: 1.05 }}
                        >
                            <p>{t("submit")}</p>
                            <FontAwesomeIcon
                                className="icon size"
                                icon={solidEnvelope}
                                size="50px"
                            />
                        </motion.button>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default ResourceUpload;
